export interface SeatAverages {
  catchSlip: number;
  effectiveLength: number;
  finishSlip: number;
  totalLength: number;
}

export interface SeatTelemetry {
  seat: number;
  rowerName?: string;
  watts: number[];
  averages: SeatAverages;
}

const STROKE_SAMPLE_COUNT = 16;

const createRange = (base: number, variance: number, seat: number): number[] => {
  return Array.from({ length: STROKE_SAMPLE_COUNT }).map((_, idx) => {
    const t = idx + seat * 0.37;
    const waveA = Math.sin(t * 0.9 + seat * 0.17);
    const waveB = Math.sin(t * 1.63 + seat * 0.42) * 0.6;
    const combined = waveA + waveB;
    return Math.round(base + combined * variance);
  });
};

// Mock rower names for each seat (stroke to bow)
const MOCK_ROWER_NAMES = [
  'Michael Chen', // Seat 1 (Stroke)
  'Marcus Johnson', // Seat 2
  'David Rodriguez', // Seat 3
  'James Wilson', // Seat 4
  'Alex Martinez', // Seat 5
  'Tyler Anderson', // Seat 6
  'Ryan Patel', // Seat 7
  "Connor O'Brien", // Seat 8 (Bow)
];

export const MOCK_ROW_METRICS: SeatTelemetry[] = Array.from({ length: 8 }).map((_, idx) => {
  const seat = idx + 1;
  const baseWatts = 380 + seat * 10;
  const variance = 8 + (seat % 3) * 3;

  const averages: SeatAverages = {
    catchSlip: 0.24 - seat * 0.012,
    effectiveLength: 9.1 + seat * 0.1,
    finishSlip: 0.2 - seat * 0.012,
    totalLength: 9.5 + seat * 0.07,
  };

  return {
    seat,
    rowerName: MOCK_ROWER_NAMES[idx],
    watts: createRange(baseWatts, variance, seat),
    averages,
  };
});

export const getSeatTelemetry = (seatNumber: number): SeatTelemetry => {
  const entry =
    MOCK_ROW_METRICS.find((metric) => metric.seat === seatNumber) ?? MOCK_ROW_METRICS[0];
  return entry;
};
